import { Seo } from "../components/seo/Seo";
import { Breadcrumbs } from "../components/seo/Breadcrumbs";
import { About } from "../components/About";

const SCHEMA = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  "@id": "https://makershub.be/over#aboutpage",
  url: "https://makershub.be/over",
  name: "Over Makers Hub — wie ben ik",
  description:
    "Tuur Vanholen vertelt waarom hij Makers Hub startte: een hands-on plek voor kinderen die hij zelf gemist heeft toen hij klein was.",
  about: {
    "@type": "Person",
    "@id": "https://makershub.be/over#tuur",
    name: "Tuur Vanholen",
    jobTitle: "Oprichter",
    worksFor: {
      "@type": "Organization",
      name: "Makers Hub",
      url: "https://makershub.be/",
    },
    description:
      "Vlaamse maker en software-/AI-ontwikkelaar. Bouwt Makers Hub als de plek voor kinderen die zelf willen knutselen met technologie.",
    sameAs: ["https://www.linkedin.com/in/tuurvanholen/"],
  },
};

export function OverPage() {
  return (
    <>
      <Seo
        title="Over Makers Hub — Wie ben ik | Tuur Vanholen"
        description="Tuur Vanholen vertelt waarom hij Makers Hub startte: een hands-on plek voor kinderen die hij zelf gemist heeft. Vlaamse maker, kleine groepen, echte hardware."
        path="/over"
        schema={SCHEMA}
      />
      <div className="container" style={{ paddingTop: 32 }}>
        <Breadcrumbs
          items={[
            { label: "Home", to: "/" },
            { label: "Wie ben ik" },
          ]}
        />
      </div>
      <About />
    </>
  );
}
